<template>
  <div class="xcard">
    <v-btn small class="mx-2" @click="$router.back()" color="info" tile outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn
    >
    <h3 class="text-center">Estado del sistema de Facturacion</h3>

    <div class="text-center">
      <v-progress-linear indeterminate v-if="loading" />
      <p><b>Sistema Manual:</b> {{ estado.isManual ? 'SI' : 'NO' }}</p>
      <p><b>Sistema Online:</b> {{ estado.isOnline ? 'SI' : 'NO' }}</p>
      <v-btn
        v-if="$store.state.CARGO.id == 1"
        class="green darken-2 white--text mr-0 mt-8"
        :disabled="loading"
        @click="presincronizar()"
      >
        <v-icon small class="mr-2">
          mdi-plus
        </v-icon>
        {{ estado.isManual ? 'Cambiar Manual a: NO' : 'Cambiar Manual a: SI' }}
      </v-btn>
    </div>
  </div>
</template>

<script>
  import xaxios from '@/xaxios';
  export default {
    data: () => ({
      dialog: false,
      loading: false,
      estado: {
        isManual: false,
        isOnline: true,
      },
    }),

    components: {},

    computed: {},

    watch: {
      dialog(val) {
        val || this.close();
      },
    },

    methods: {
      verificarOnline() {
        this.loading = true;
        let vue = this;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/empresas/isonline`,
          headers: {
            'Content-Type': 'application/json',
            apikey: this.$store.getters.getApiKey,
          },
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            window.console.log('verificarOnline', data);
            if (data) {
              vue.estado.isManual = data.isManual;
              vue.estado.isOnline = data.isOnline;
            }
            vue.loading = false;
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loading = false;
          });
      },
      presincronizar() {
        let vue = this;
        let opt = {
          verification: 'si',
          verificationHelp: 'Escriba "[+:verification]" para cambiar el estado del sistema.',
          okText: 'Cambiar',
          cancelText: 'cancelar',
          backdropClose: false,
          animation: 'bounce',
          loader: true,
          type: 'classic',
        };
        var message = {
          title: 'Confirmar cambio de estado',
          body: '<br> <b>NOTA:</b> Esta accion es irreversible.',
        };
        this.$dialog
          .confirm(message, opt)
          .then(function(dialog) {
            vue.finalizarItem(dialog);
          })
          .catch(function() {});
      },
      finalizarItem(dialog) {
        let vue = this;
        this.loading = true;
        var config = {
          method: 'post',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/empresas/manual`,
          headers: {
            'Content-Type': 'application/json',
            apikey: this.$store.getters.getApiKey,
          },
          data: {
            manual: !vue.estado.isManual,
          },
        };

        xaxios.request(config)
          .then(function(response) {
            window.console.log(response);
            vue.verificarOnline();
            dialog.close();
            vue.$root.$notify.show('Ok', { color: 'success' });
          })
          .catch(function(error) {
            window.console.log(error.response);
            dialog.close();
            vue.loading = false;
            vue.$root.$notify.show('Error', { color: 'red' });
          });
      },
    },
    mounted() {
      this.verificarOnline();
    },
  };
</script>
